import {FC} from "react";
import ISpinner from "../../interfaces/Components/ISpinner";

const Spinner:FC<ISpinner> = ({width, height, color}) => {

    return <div role="status">
        <svg
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            className={`${width} ${height} animate-spin ${color}`}
            viewBox="0 0 24 24"
            fill="none"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M21 12a9 9 0 11-6.219-8.56" style={{fill: 'transparent'}} />
        </svg>
        <span className="sr-only">Loading...</span>
    </div>
}

export default Spinner;